export var requestConstants = {
    START: 'REQUEST_START',
    SUCCESS: 'REQUEST_SUCCESS',
    FAILURE: 'REQUEST_FAILURE',
};
